import { IDLE_LIMIT_MS } from "./types.js";

/**
 * The client half of the idle limit (ADM-07): any pointer or key activity
 * resets the clock; thirty minutes without it signs the user out. The
 * provider's own session idle timeout is the server half.
 */
export function watchInactivity(
  onIdle: () => void,
  limitMs = IDLE_LIMIT_MS,
  target: Pick<Window, "addEventListener" | "removeEventListener"> = window,
): () => void {
  let timer: ReturnType<typeof setTimeout> | undefined;
  const reset = () => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(onIdle, limitMs);
  };
  const events = ["pointerdown", "keydown", "scroll", "touchstart"] as const;
  for (const e of events) target.addEventListener(e, reset, { passive: true });
  reset();
  return () => {
    if (timer) clearTimeout(timer);
    for (const e of events) target.removeEventListener(e, reset);
  };
}
